import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $rewardsBalanceStore } from '@lib/store';
import { cn, PaletteUtils } from '@shared/utils';
import { Icon, Text } from '@shared/widgets';
import RewardsIcon from '@assets/icons/rewards.svg';

interface BalanceProps {
  className?: string;
}

export const Balance = (props: BalanceProps) => {
  const rewardsBalanceStore = useUnit($rewardsBalanceStore.store);

  const { t } = useTranslation('rewards');

  return (
    <section
      className={cn(
        'flex items-center justify-center bg-white p-6',
        PaletteUtils.isInsigniaPalette && 'dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black dark:bg-soft-black',
        props.className,
      )}
    >
      <div
        className={cn(
          'flex w-full max-w-xl items-center gap-5 rounded-sm bg-primary px-6 py-5',
          'max-md:gap-4 max-md:p-4',
          PaletteUtils.isVcfcPalette && 'rounded-xl',
        )}
      >
        <Icon
          className='flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-white/60'
          icon={<RewardsIcon width={28} height={28} />}
          color='white'
        />
        <ul className='flex flex-col gap-1'>
          <Text tag='li' size='sm' color='white'>
            {t('balance.label')}
          </Text>
          <li className='flex items-baseline gap-2'>
            <Text weight='bold' size='4xl' color='white'>
              {rewardsBalanceStore.data?.availableBalance?.toLocaleString('en-US', { minimumFractionDigits: 2 }) || '-'}
            </Text>
            <Text size='sm' color='white'>
              {t('balance.points')}
            </Text>
          </li>
        </ul>
      </div>
    </section>
  );
};
